import Image from 'next/image'
import { useRef, useState } from 'react'
import { isMobile, isTablet } from 'react-device-detect'
import { useTranslation } from 'react-i18next'
import Slider from 'react-slick'
import { FCC } from '~/core/@types/global'
import { cn } from '~/core/ui/utils'
import SectionContainer from './components/section/SectionContainer'

const SlickSlider = Slider as unknown as React.FC<any>

const ICON_1 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20C19.1046 20 20 19.1046 20 18C20 16.8954 19.1046 16 18 16ZM14 18C14 15.7909 15.7909 14 18 14C20.2091 14 22 15.7909 22 18C22 20.2091 20.2091 22 18 22C15.7909 22 14 20.2091 14 18Z"
      fill="#272A35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4ZM2 6C2 3.79086 3.79086 2 6 2C8.20914 2 10 3.79086 10 6C10 8.20914 8.20914 10 6 10C3.79086 10 2 8.20914 2 6Z"
      fill="#272A35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6C12 5.44772 12.4477 5 13 5H16C16.7956 5 17.5587 5.31607 18.1213 5.87868C18.6839 6.44129 19 7.20435 19 8V15C19 15.5523 18.5523 16 18 16C17.4477 16 17 15.5523 17 15V8C17 7.73478 16.8946 7.48043 16.7071 7.29289C16.5196 7.10536 16.2652 7 16 7H13C12.4477 7 12 6.55228 12 6Z"
      fill="#272A35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 8C6.55228 8 7 8.44772 7 9V21C7 21.5523 6.55228 22 6 22C5.44772 22 5 21.5523 5 21V9C5 8.44772 5.44772 8 6 8Z"
      fill="#272A35"
    />
  </svg>
)

const ICON_2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none">
    <path
      d="M19.5002 1.00098C19.7923 1.001 20.0813 1.05943 20.3508 1.17188C20.6195 1.28396 20.8636 1.44772 21.0686 1.6543L22.343 2.92871C22.551 3.1326 22.717 3.37613 22.8303 3.64453C22.9446 3.91523 23.0032 4.20618 23.0032 4.5C23.0032 4.7938 22.9445 5.08478 22.8303 5.35547C22.717 5.62386 22.551 5.86741 22.343 6.07129L6.07153 22.3428C5.86765 22.5508 5.6241 22.7168 5.35571 22.8301C5.085 22.9444 4.79409 23.0029 4.50024 23.0029C4.20646 23.0029 3.91545 22.9443 3.64478 22.8301C3.37638 22.7168 3.13284 22.5508 2.92896 22.3428L1.65454 21.0684C1.44797 20.8633 1.2842 20.6192 1.17212 20.3506C1.05969 20.081 1.00122 19.7921 1.00122 19.5C1.00123 19.2079 1.05967 18.919 1.17212 18.6494C1.28421 18.3808 1.44794 18.1367 1.65454 17.9316L1.65649 17.9297L17.929 1.65625L17.9309 1.6543C18.1359 1.44773 18.3801 1.28399 18.6487 1.17188C18.9183 1.05938 19.2081 1.00098 19.5002 1.00098ZM3.06372 19.3506C3.04408 19.37 3.02851 19.3935 3.01782 19.4189C3.00714 19.4446 3.00123 19.4723 3.00122 19.5C3.00122 19.5278 3.00713 19.5554 3.01782 19.5811C3.02851 19.6066 3.04406 19.63 3.06372 19.6494L4.35669 20.9424C4.37529 20.9615 4.39756 20.9769 4.42212 20.9873C4.44674 20.9977 4.47352 21.0029 4.50024 21.0029C4.52677 21.0029 4.55293 20.9976 4.57739 20.9873C4.60201 20.9769 4.62516 20.9615 4.6438 20.9424L4.65259 20.9326L15.5852 9.99902L14.0002 8.41406L3.06372 19.3506ZM19.0002 13C19.5524 13.0001 20.0002 13.4478 20.0002 14V15H21.0002C21.5524 15.0001 22.0002 15.4478 22.0002 16C22.0002 16.5522 21.5524 16.9999 21.0002 17H20.0002V18C20.0002 18.5522 19.5524 18.9999 19.0002 19C18.448 19 18.0002 18.5523 18.0002 18V17H17.0002C16.448 17 16.0002 16.5523 16.0002 16C16.0002 15.4477 16.448 15 17.0002 15H18.0002V14C18.0002 13.4477 18.448 13 19.0002 13ZM5.00024 5C5.55242 5.00013 6.00024 5.4478 6.00024 6V7H7.00024C7.55242 7.00013 8.00024 7.4478 8.00024 8C8.00024 8.5522 7.55242 8.99987 7.00024 9H6.00024V10C6.00024 10.5522 5.55242 10.9999 5.00024 11C4.44796 11 4.00024 10.5523 4.00024 10V9H3.00024C2.44796 9 2.00024 8.55228 2.00024 8C2.00024 7.44772 2.44796 7 3.00024 7H4.00024V6C4.00024 5.44772 4.44796 5 5.00024 5ZM19.5002 3.00098C19.4725 3.00098 19.4448 3.00689 19.4192 3.01758C19.3936 3.02826 19.3703 3.04378 19.3508 3.06348L15.4143 7L16.9993 8.58496L20.9426 4.64355C20.9617 4.62496 20.9772 4.60266 20.9875 4.57812C20.9979 4.55351 21.0032 4.52672 21.0032 4.5C21.0032 4.47329 20.9979 4.44648 20.9875 4.42188C20.9772 4.39737 20.9617 4.37502 20.9426 4.35645L20.9329 4.34766L19.6526 3.06738L19.6497 3.06348C19.6302 3.04385 19.6068 3.02826 19.5813 3.01758C19.5557 3.00691 19.5279 3.001 19.5002 3.00098ZM10.0002 1C10.5524 1.00013 11.0002 1.4478 11.0002 2L11.1018 2.00488C11.6063 2.05588 12.0002 2.48208 12.0002 3C12.0002 3.51792 11.6063 3.94412 11.1018 3.99512L11.0002 4L10.9944 4.10254C10.943 4.60655 10.5178 4.99988 10.0002 5C9.48258 5 9.05647 4.60666 9.00513 4.10254L9.00024 4L8.89771 3.99512C8.39346 3.9439 8.00024 3.51776 8.00024 3C8.00024 2.48224 8.39346 2.0561 8.89771 2.00488L9.00024 2C9.00024 1.44772 9.44796 1 10.0002 1Z"
      fill="#272A35"
    />
  </svg>
)

const ICON_3 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none">
    <path
      d="M12 1C14.5629 1 16.9251 1.34449 18.6807 1.92969C19.5531 2.22053 20.3315 2.58931 20.9121 3.04688C21.4814 3.4956 22 4.14818 22 5V19C22 19.8494 21.4868 20.5023 20.918 20.9531C20.3391 21.4118 19.5626 21.7805 18.6914 22.0713C16.9387 22.6564 14.5766 23 12 23C9.42339 23 7.06132 22.6564 5.30859 22.0713C4.43745 21.7805 3.66087 21.4118 3.08203 20.9531C2.51316 20.5023 2 19.8494 2 19V5C2 4.14818 2.51859 3.4956 3.08789 3.04688C3.66849 2.58931 4.4469 2.22053 5.31934 1.92969C7.07494 1.34449 9.43715 1 12 1ZM20 14.5293C19.6018 14.7331 19.1608 14.9146 18.6914 15.0713C16.9387 15.6564 14.5766 16 12 16C9.42339 16 7.06132 15.6564 5.30859 15.0713C4.83923 14.9146 4.39821 14.7331 4 14.5293V19C4 19.0019 3.99977 19.007 4.00293 19.0176C4.00647 19.0293 4.01516 19.0521 4.03516 19.085C4.0773 19.1541 4.16351 19.2584 4.32422 19.3857C4.6516 19.6451 5.18794 19.9223 5.94141 20.1738C7.43865 20.6737 9.57676 21 12 21C14.4232 21 16.5614 20.6737 18.0586 20.1738C18.8121 19.9223 19.3484 19.6451 19.6758 19.3857C19.8365 19.2584 19.9227 19.1541 19.9648 19.085C19.9848 19.0521 19.9935 19.0293 19.9971 19.0176C20.0002 19.007 20 19.0019 20 19V14.5293ZM20 7.52441C19.5986 7.72973 19.154 7.9125 18.6807 8.07031C16.9251 8.65551 14.5629 9 12 9C9.43715 9 7.07494 8.65551 5.31934 8.07031C4.84596 7.9125 4.40136 7.72973 4 7.52441V12C4 12.0019 3.99977 12.007 4.00293 12.0176C4.00647 12.0293 4.01516 12.0521 4.03516 12.085C4.0773 12.1541 4.16351 12.2584 4.32422 12.3857C4.6516 12.6451 5.18794 12.9223 5.94141 13.1738C7.43865 13.6737 9.57676 14 12 14C14.4232 14 16.5614 13.6737 18.0586 13.1738C18.8121 12.9223 19.3484 12.6451 19.6758 12.3857C19.8365 12.2584 19.9227 12.1541 19.9648 12.085C19.9848 12.0521 19.9935 12.0293 19.9971 12.0176C20.0002 12.007 20 12.0019 20 12V7.52441ZM12 3C9.59229 3 7.45391 3.32656 5.95215 3.82715C5.19606 4.07918 4.65634 4.35796 4.32617 4.61816C4.16419 4.74586 4.07758 4.84984 4.03516 4.91895C4.01518 4.95153 4.00637 4.97318 4.00293 4.98438L4 5L4.00293 5.01562C4.00637 5.02682 4.01518 5.04847 4.03516 5.08105C4.07758 5.15016 4.16419 5.25414 4.32617 5.38184C4.65634 5.64204 5.19606 5.92082 5.95215 6.17285C7.45391 6.67344 9.59229 7 12 7C14.4077 7 16.5461 6.67344 18.0479 6.17285C18.8039 5.92082 19.3437 5.64204 19.6738 5.38184C19.8358 5.25414 19.9224 5.15016 19.9648 5.08105C19.9848 5.04847 19.9936 5.02682 19.9971 5.01562C20.0001 5.00554 20 5.00089 20 5C20 4.99927 20.0002 4.99473 19.9971 4.98438C19.9936 4.97318 19.9848 4.95153 19.9648 4.91895C19.9224 4.84984 19.8358 4.74586 19.6738 4.61816C19.3437 4.35796 18.8039 4.07918 18.0479 3.82715C16.5461 3.32656 14.4077 3 12 3Z"
      fill="#272A35"
    />
  </svg>
)

const UseCasesSection: FCC<{ className?: string }> = ({ className }) => {
  const { t, i18n } = useTranslation()
  const [activeIndex, setActiveIndex] = useState(0)
  const useCasesSliderRef = useRef<Slider>(null)

  const settings = {
    dots: false,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  }

  const SECTIONS = [
    {
      title: t('lp:use_cases:section_1_title'),
      contentTag: t('lp:use_cases:section_1_content_tag'),
      contentImage: '/img/feature/lp/new/use_cases01.png',
      contentTitle: t('lp:use_cases:section_1_content_title'),
      contentBox01Type: t('lp:use_cases:section_1_content_box_1_type'),
      contentBox01Title: t('lp:use_cases:section_1_content_box_1_title'),
      contentBox01Description: t(
        'lp:use_cases:section_1_content_box_1_description'
      ),
      contentBox02Type: t('lp:use_cases:section_1_content_box_2_type'),
      contentBox02Title: t('lp:use_cases:section_1_content_box_2_title'),
      contentBox02Description: t(
        'lp:use_cases:section_1_content_box_2_description'
      ),
      contentBox03Type: t('lp:use_cases:section_1_content_box_3_type'),
      contentBox03Title: t('lp:use_cases:section_1_content_box_3_title'),
      contentBox03Description: t(
        'lp:use_cases:section_1_content_box_3_description'
      ),
      contentLink: '#'
    },
    {
      title: t('lp:use_cases:section_2_title'),
      contentTag: t('lp:use_cases:section_2_content_tag'),
      contentImage: '/img/feature/lp/new/use_cases02.png',
      contentTitle: t('lp:use_cases:section_2_content_title'),
      contentBox01Type: t('lp:use_cases:section_2_content_box_1_type'),
      contentBox01Title: t('lp:use_cases:section_2_content_box_1_title'),
      contentBox01Description: t(
        'lp:use_cases:section_2_content_box_1_description'
      ),
      contentBox02Type: t('lp:use_cases:section_2_content_box_2_type'),
      contentBox02Title: t('lp:use_cases:section_2_content_box_2_title'),
      contentBox02Description: t(
        'lp:use_cases:section_2_content_box_2_description'
      ),
      contentBox03Type: t('lp:use_cases:section_2_content_box_3_type'),
      contentBox03Title: t('lp:use_cases:section_2_content_box_3_title'),
      contentBox03Description: t(
        'lp:use_cases:section_2_content_box_3_description'
      ),
      contentLink: '#'
    },
    {
      title: t('lp:use_cases:section_3_title'),
      contentTag: t('lp:use_cases:section_3_content_tag'),
      contentImage: '/img/feature/lp/new/use_cases03.png',
      contentTitle: t('lp:use_cases:section_3_content_title'),
      contentBox01Type: t('lp:use_cases:section_3_content_box_1_type'),
      contentBox01Title: t('lp:use_cases:section_3_content_box_1_title'),
      contentBox01Description: t(
        'lp:use_cases:section_3_content_box_1_description'
      ),
      contentBox02Type: t('lp:use_cases:section_3_content_box_2_type'),
      contentBox02Title: t('lp:use_cases:section_3_content_box_2_title'),
      contentBox02Description: t(
        'lp:use_cases:section_3_content_box_2_description'
      ),
      contentBox03Type: t('lp:use_cases:section_3_content_box_3_type'),
      contentBox03Title: t('lp:use_cases:section_3_content_box_3_title'),
      contentBox03Description: t(
        'lp:use_cases:section_3_content_box_3_description'
      ),
      contentLink: '#'
    }
  ]

  return (
    <SectionContainer
      title="lp:use_cases:title"
      tagLabel="lp:use_cases:tag"
      tagColor="bg-green-100 text-green-800"
      className={cn(className, 'pb-5 my-[44px] desktop:my-[120px]')}>
      {!isMobile || isTablet ? (
        <div className="relative">
          <div className="flex align-middle w-full justify-center mt-6">
            {SECTIONS.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  setActiveIndex(index)
                  useCasesSliderRef?.current?.slickGoTo(index)
                }}
                className="animate-fadeInUp border-gray-300 border py-2 px-3 rounded bg-white mx-[6px] cursor-pointer hover:bg-gray-50">
                <span
                  className={cn(
                    'text-base font-medium',
                    activeIndex === index ? 'text-primary-400' : 'text-gray-600'
                  )}>
                  {item.title}
                </span>
              </div>
            ))}
          </div>

          <div className="w-full mt-8">
            <SlickSlider
              {...settings}
              ref={useCasesSliderRef}
              afterChange={(currentSlide: number) =>
                setActiveIndex(currentSlide)
              }>
              {SECTIONS.map((item, index) => (
                <div
                  key={`screenshot-image-${index}`}
                  className="!border-0 !outline-0">
                  <div className="flex justify-center">
                    <div className="py-[33px] pr-[36px] flex-1">
                      <span className="bg-gray-600 text-white px-1 uppercase text-sm font-medium leading-5 rounded-sm">
                        {item.contentTag}
                      </span>
                      <p className="mt-2 text-2xl font-medium text-gray-900">
                        {item.contentTitle}
                      </p>
                      <div className="mt-10 flex flex-wrap w-full">
                        <div className="flex-1 w-1/2 min-w-[50%] pr-3">
                          {ICON_1}
                          <div className="mt-3">
                            <span className="font-medium text-lg text-gray-900">
                              {item.contentBox01Title}
                            </span>
                            <p className="font-normal text-base text-gray-700">
                              {item.contentBox01Description}
                            </p>
                          </div>
                        </div>
                        <div className="flex-1 w-1/2 min-w-[50%] pl-3">
                          {ICON_2}
                          <div className="mt-3">
                            <span className="font-medium text-lg text-gray-900">
                              {item.contentBox02Title}
                            </span>
                            <p className="font-normal text-base text-gray-700">
                              {item.contentBox02Description}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="mt-8 flex flex-wrap w-full">
                        <div className="flex-1 w-1/2 min-w-[50%]">
                          {ICON_3}
                          <div className="mt-3">
                            <span className="font-medium text-lg text-gray-900">
                              {item.contentBox03Title}
                            </span>
                            <p className="font-normal text-base text-gray-700">
                              {item.contentBox03Description}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <Image
                        src={item.contentImage}
                        width={458}
                        height={0}
                        alt={`${item.contentImage}-image`}
                        className="h-auto"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </SlickSlider>
          </div>
        </div>
      ) : (
        <div className="relative">
          <div className="flex flex-col w-full justify-center mt-8">
            {SECTIONS.map((item, index) => (
              <div key={index} className="w-full">
                <div className="flex items-center">
                  <span className="border-gray-300 border inline-block mx-auto py-2 px-3 rounded bg-white mb-5 cursor-pointer hover:bg-gray-50 text-base font-medium text-primary-400">
                    {item.title}
                  </span>
                </div>

                <div>
                  <Image
                    src={item.contentImage}
                    width={458}
                    height={0}
                    alt={`${item.contentImage}-image`}
                    className="h-auto"
                  />
                </div>

                <div className="flex-1">
                  <span className="bg-gray-600 text-white px-1 uppercase text-sm font-medium leading-5 rounded-sm">
                    {item.contentTag}
                  </span>
                  <p className="mt-2 text-2xl font-medium text-gray-900">
                    {item.contentTitle}
                  </p>
                  <div className="mt-10 flex flex-wrap w-full space-y-6">
                    <div className="">
                      {ICON_1}
                      <div className="mt-3">
                        <span className="font-medium text-lg text-gray-900">
                          {item.contentBox01Title}
                        </span>
                        <p className="font-normal text-base text-gray-700">
                          {item.contentBox01Description}
                        </p>
                      </div>
                    </div>
                    <div className="">
                      {ICON_2}
                      <div className="mt-3">
                        <span className="font-medium text-lg text-gray-900">
                          {item.contentBox02Title}
                        </span>
                        <p className="font-normal text-base text-gray-700">
                          {item.contentBox02Description}
                        </p>
                      </div>
                    </div>
                    <div className="">
                      {ICON_3}
                      <div className="mt-3">
                        <span className="font-medium text-lg text-gray-900">
                          {item.contentBox03Title}
                        </span>
                        <p className="font-normal text-base text-gray-700">
                          {item.contentBox03Description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {index < SECTIONS.length - 1 ? (
                  <div className="my-8 h-px bg-gray-100" />
                ) : null}
              </div>
            ))}
          </div>
        </div>
      )}
    </SectionContainer>
  )
}

export default UseCasesSection
